export default "/images/458c3bb663d6a495b1962611f73a4493.avif";